// @flow
import config from '../../config';
import { buildQueryParams } from './search-order-analytics-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.ORDER_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getNoCustomers = (query): any => makeApiCall('/customers', query);

const getNoOrders = (query): any => makeApiCall('/orders', query);

const getTotalOrderRevenue = (query): any => makeApiCall('/total_order_revenue', query);

const getDailyRevenue = (query): any => makeApiCall('/daily_revenue', query);

const getTopCustomers = (query): any => makeApiCall('/top_customers', query);

const getTopProducts = (query): any => makeApiCall('/top_products', query);

const getTopSources = (query): any => makeApiCall('/top_sources', query);

export {
    getNoCustomers,
    getNoOrders,
    getTotalOrderRevenue,
    getDailyRevenue,
    getTopCustomers,
    getTopProducts,
    getTopSources,
};
